import { render, staticRenderFns } from "./detailIngameFlag.vue?vue&type=template&id=67f03676&scoped=true"
import script from "./detailIngameFlag.vue?vue&type=script&lang=js"
export * from "./detailIngameFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f03676",
  null
  
)

export default component.exports